import React from 'react';
import {DisplayText, TextStyle, TextContainer, Icon} from '@shopify/polaris';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {
  ChecklistAlternateMajorMonotone,
  ChecklistMajorMonotone,
  FlagMajorMonotone,
} from '@shopify/polaris-icons';
import {
  Heading,
  Paragraph,
} from 'sections/services-marketplace/experts/components';

import styles from './HowItWorks.scss';

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

function HowItWorks({i18n}: CombinedProps) {
  return (
    <div className={styles.HowItWorks}>
      <div className={styles.Heading}>
        <TextContainer>
          <DisplayText size="large" element="h2">
            {i18n.translate('Home.HowItWorks.title')}
          </DisplayText>
          <DisplayText size="small" element="p">
            <TextStyle variation="subdued">
              {i18n.translate('Home.HowItWorks.intro')}
            </TextStyle>
          </DisplayText>
        </TextContainer>
      </div>
      <div className={styles.Steps}>
        <div className={styles.Step}>
          <div className={styles.IconContainer}>
            <Icon source={ChecklistAlternateMajorMonotone} color="white" />
          </div>
          <div className={styles.ContentContainer}>
            <TextContainer spacing="tight">
              <Heading element="h3">
                {i18n.translate('Home.HowItWorks.step1.title')}
              </Heading>
              <Paragraph>
                <TextStyle variation="subdued">
                  {i18n.translate('Home.HowItWorks.step1.text')}
                </TextStyle>
              </Paragraph>
            </TextContainer>
          </div>
        </div>
        <div className={styles.Step}>
          <div className={styles.IconContainer}>
            <Icon source={ChecklistMajorMonotone} color="white" />
          </div>
          <div className={styles.ContentContainer}>
            <TextContainer spacing="tight">
              <Heading element="h3">
                {i18n.translate('Home.HowItWorks.step2.title')}
              </Heading>
              <Paragraph>
                <TextStyle variation="subdued">
                  {i18n.translate('Home.HowItWorks.step2.text')}
                </TextStyle>
              </Paragraph>
            </TextContainer>
          </div>
        </div>
        <div className={styles.Step}>
          <div className={styles.IconContainer}>
            <Icon source={FlagMajorMonotone} color="white" />
          </div>
          <div className={styles.ContentContainer}>
            <TextContainer spacing="tight">
              <Heading element="h3">
                {i18n.translate('Home.HowItWorks.step3.title')}
              </Heading>
              <Paragraph>
                <TextStyle variation="subdued">
                  {i18n.translate('Home.HowItWorks.step3.text')}
                </TextStyle>
              </Paragraph>
            </TextContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withI18n()(HowItWorks);
